
import PaginationV2 from '@/components/ui/Pagination-V2.vue';
import { constants, IsUserSearchEventAt } from '@/config/constant.config';
import {
  AskAnswerStateCssStyle,
  AskShowStateCssStyle,
} from '@/helper/element-style.helper';
import { defineComponent, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import cookieHelper from '../../helper/cookie.helper';
import dateTimeHelper from '../../helper/datetime.helper';
import swal from '../../helper/swal.helper';
import CrudModel, { Jin } from '../../models/jin.model';
import JinCategoriesModel, {
  JinCategory,
} from '../../models/jinCategories.model';

export default defineComponent({
  name: 'Jin',
  props: {},
  components: {
    PaginationV2,
  },
  setup: () => {
    const router = useRouter();
    const route = useRoute();
    const userSearchEventFlag = ref<IsUserSearchEventAt>(IsUserSearchEventAt.N);
    const perpage = constants().DEFAULT_PERPAGE;
    const loading = ref(false);
    const jins = ref<Jin[]>([]);
    const orderOptions = ref([[]]);
    const listJinCategories = ref<JinCategory[]>([]);
    const jinCategories = ref<any>({});
    const filter = ref({
      title: '',
      category_id: '',
      brand: '',
      show: '',
    });
    const usinUserName = ref(cookieHelper.getCookie('usin_name'));

    type filterKeyType = 'title' | 'category_id' | 'show' | 'brand';

    const filterConditions = ref<Array<any>>([]);

    function updateData(items: Jin[]) {
      loading.value = false;
      jins.value = items;
    }
    function isLoading(status: boolean) {
      loading.value = status;
    }
    const editRecord = (id: string) => {
      router.push({
        path: `/jin/edit/${id}`,
        query: route.query,
      });
    };
    async function deleteRecord(id: string) {
      swal.simpleDeleteConfirm(async () => {
        loading.value = true;
        await CrudModel.delete(id);
        jins.value = await CrudModel.getAll();
        loading.value = false;
        await searchHandler();
      });
    }

    const addRecord = () => {
      router.push({
        path: '/jin/add',
        query: route.query,
      });
    };

    async function searchHandler() {
      if (userSearchEventFlag.value === IsUserSearchEventAt.Y) {
        route.query.page = '1';
      }
      filterConditions.value = [];

      setSearchFilterCondition('title');
      setSearchFilterCondition('category_id');
      setSearchFilterCondition('brand');
      setSearchFilterCondition('show');
    }

    /**
     * 데이터 검색 조건 셋팅
     * @param filterKey
     * @param replaceFilterValue
     */
    function setSearchFilterCondition(
      filterKey: filterKeyType,
      replaceFilterValue?: string,
    ): void {
      if (filter.value[filterKey].trim() || replaceFilterValue) {
        filterConditions.value.push([
          [filterKey],
          replaceFilterValue ?? filter.value[filterKey],
        ]);
      } else if (
        // 페이지가 새로고침되었을 때 또는 뒤로가기로 왔을 때 url에 검색 관련 쿼리스트링이 있으면, 검색 조건에 추가 합니다.
        ((!filter.value[filterKey].trim() && route.query[filterKey]?.length) ||
          replaceFilterValue) &&
        userSearchEventFlag.value === IsUserSearchEventAt.N
      ) {
        filterConditions.value.push([
          [filterKey],
          replaceFilterValue ?? route.query[filterKey],
        ]);
        filter.value[filterKey] =
          replaceFilterValue ?? `${route.query[filterKey]}`;
      }
    }

    /**
     * Reset 버튼을 클릭했을 때 검색 조건을 초기화 합니다.
     */
    async function resetFilter() {
      filter.value.title = '';
      filter.value.show = '';
      filter.value.category_id = '';
      filter.value.brand = '';

      userSearchEventFlag.value = IsUserSearchEventAt.Y;
      await searchHandler();
    }

    onMounted(async () => {
      const jinCategoriesResponse = await JinCategoriesModel.getAll(
        [],
        [],
        1,
        1000,
      );
      listJinCategories.value = jinCategoriesResponse.items;

      for (const category of listJinCategories.value) {
        jinCategories.value[category.id ?? 'unknown'] = category.name;
      }

      await searchHandler();
    });

    return {
      jins,
      listJinCategories,
      jinCategories,
      loading,
      orderOptions,
      perpage,
      filterConditions,
      updateData,
      isLoading,
      CrudModel,
      addRecord,
      deleteRecord,
      editRecord,
      AskShowStateCssStyle,
      AskAnswerStateCssStyle,
      dateTimeHelper,
      userSearchEventFlag,
      IsUserSearchEventAt,
      searchHandler,
      filter,
      resetFilter,
      usinUserName,
    };
  },
});
